


















import Vue from 'vue';
import PeerGroupListCreator from '@/components/PeerGroupListCreator.vue';

export default Vue.extend({
  components: {
    PeerGroupListCreator
  },

  props: {
    initialName: String
  },

  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    onCreate(groupInfo: {
      name: string;
      section: string;
      description: string;
    }) {
      this.$emit('create-group', groupInfo);

      this.close();
    },

    close() {
      this.isOpen = false;
    }
  }
});
